module.exports = __webpack_public_path__ + "media/St 4-dishwasher-correct.cc2fbec5.wav";